import sample_1 from './twinstar.jpg';

export const twinstarImpressions = {
    sample_1,
};
